<div class="kanban-column">
  <div class="column-header">
    <div class="column-title-section">
      <span class="title--medium title">{{ phaseName() }}</span>
      <span class="amount label--small">{{ cardCount() }}</span>
    </div>
  </div>

  <div
    class="cards-container"
    cdkDropList
    [id]="phase()"
    [cdkDropListConnectedTo]="connectedDropLists()"
    visioInfiniteScroll
    [threshold]="{ type: 'pixels', value: 400 }"
    (thresholdReached)="onRequestMoreCards()"
  >
    @for (card of cards(); track card.id) {
      <div class="card-wrapper" cdkDrag [cdkDragData]="card" [cdkDragDisabled]="true">
        <app-kanban-card
          [card]="card"
          (cardClick)="onCardClick($event)"
          [actionsConfig]="actionsConfig()"
          [fieldsToShow]="fieldsToShow()"
          [tagsConfig]="tagsConfig()"
          (openPhaseForm)="openPhaseForm.emit($event)"
          (tagSelected)="onTagSelected($event)"
          (tagRemoved)="onTagRemoved($event)"
        >
        </app-kanban-card>
      </div>
    }
    <div class="loading-container">
      @if (loading()) {
        <visio-loading [size]="100"></visio-loading>
      }
    </div>
  </div>
</div>
